<div class="try-for-free o-flex o-flex--column">
  <button mat-raised-button color="primary" (click)="tryForFree()">{{getButtonName()}}</button>
  <span class="try-for-free__extra-info u-font-weight-700 line-height-16 u-font-size-14 u-margin-top-20">{{getPriceText()}}</span>
</div>
